import { useState } from "react";
import "./Register.css"; // Importar el archivo CSS
import { supabase } from "../../Servicios/supabaseClient";
import titulo from '../../Img/titulo.png'
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { ClipLoader } from 'react-spinners';

export default function Register() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [newUser, setNewUser] = useState({
    empresa: "",
    email: "",
    password: "",
    repassword: "",
    nombre: "",
    cuit: ""
  })

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewUser({
      ...newUser,
      [name]: value
    });
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!newUser.empresa || !newUser.email || !newUser.password || !newUser.repassword || !newUser.nombre || !newUser.cuit) {
      Swal.fire({
        icon: 'error',
        title: 'Campos incompletos',
        text: 'Por favor, completa todos los campos.',
        confirmButtonColor: '#d33'
      });
      return;
    }

    if (newUser.password !== newUser.repassword) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Las contraseñas no coinciden',
        confirmButtonColor: '#d33'
      });
      return;
    }

    setLoading(true);

    try {
      const { data, error } = await supabase.auth.signUp({
        email: newUser.email,
        password: newUser.password,
        options: {
          data: {
            nombre: newUser.nombre,
            empresa: newUser.empresa,
            cuit: newUser.cuit,
          }
        }
      });

      if (error) throw error;

      Swal.fire({
        icon: 'success',
        title: '¡Registro exitoso!',
        text: 'Revisa tu email para confirmar tu cuenta.',
        confirmButtonColor: '#3085d6'
      }).then(() => {
        navigate("/login");
      });

    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: `Error en el registro: ${error.message}`,
        confirmButtonColor: '#d33'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="registerPage">
      {loading && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999
        }}>
          <ClipLoader color="#ffffff" size={50} />
        </div>
      )}
      <div className="registerContainer">
        <img src={titulo} style={{ width: "100%" }} alt="" />
        <p className="registerSubtitle" style={{ margin: "0.5rem" }}>¡Registrate en QuantumNodo!</p>

        <form className="registerForm" onSubmit={handleSubmit}>
          <div className="inputGroup">
            <label htmlFor="empresa" className="inputLabel">Empresa</label>
            <input
              type="text"
              id="empresa"
              name="empresa"
              className="inputField"
              placeholder="Ingresa tu empresa"
              value={newUser.empresa}
              onChange={handleChange}
            />
          </div>
          <div className="inputGroup">
            <label htmlFor="cuit" className="inputLabel">CUIT</label>
            <input
              type="text"
              id="cuit"
              name="cuit"
              className="inputField"
              placeholder="Ingresa tu cuit"
              value={newUser.cuit}
              onChange={handleChange}
            />
          </div>
          <div className="inputGroup">
            <label htmlFor="nombre" className="inputLabel">Nombre</label>
            <input
              type="text"
              id="nombre"
              name="nombre"
              className="inputField"
              placeholder="Ingresa tu nombre"
              value={newUser.nombre}
              onChange={handleChange}
            />
          </div>

          <div className="inputGroup">
            <label htmlFor="email" className="inputLabel">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              className="inputField"
              placeholder="Ingresa tu email"
              value={newUser.email}
              onChange={handleChange}
            />
          </div>

          <div className="inputGroup">
            <label htmlFor="password" className="inputLabel">Contraseña</label>
            <input
              type="password"
              id="password"
              name="password"
              className="inputField"
              placeholder="Ingresa tu contraseña"
              value={newUser.password}
              onChange={handleChange}
            />
          </div>
          <div className="inputGroup">
            <label htmlFor="repassword" className="inputLabel">Repita su contraseña</label>
            <input
              type="password"
              id="repassword"
              name="repassword"
              className="inputField"
              placeholder="Ingresa tu contraseña nuevamente"
              value={newUser.repasswordpassword}
              onChange={handleChange}
            />
          </div>

          <button type="submit" className="registerBtn">Registrarse</button>
        </form>

        <div className="registerFooter">
          <p>¿Ya tienes cuenta? <a href="/login" className="registerLink">Inicia sesión aquí</a></p>
        </div>
      </div>
    </div>
  );
}
